import Trustpilot from './Trustpilot.vue'

export default Trustpilot
